<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_facility") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facilityNameAr')"
            v-model.trim="data.name_ar"
            :maxlength="50"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facilityNameEn')"
            v-model.trim="data.name_en"
            :maxlength="50"
            required
          />

          <div class="input_wrapper switch_wrapper my-3 col-4">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>

          <ChangableMapComponent
            :lat="parseFloat(data.lat)"
            :lng="parseFloat(data.long)"
            selection-mode="points"
            :points="data.shape"
            @update:lat="data.lat = $event"
            @update:lng="data.long = $event"
            @update:points="onShapeUpdate"
            @update:placeName="updateAddress"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "CreateFacility",
  components: {
    ChangableMapComponent,
  },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        name_ar: null,
        name_en: null,
        address: null,
        lat: 24.7136,
        long: 46.6753,
        shape: [],
        radius: null,
        is_active: true,
      },
    };
  },

  methods: {
    onRadiusInput(value) {
      this.data.radius = String(value || "").replace(/\D/g, "");
    },

    updateAddress(placeName) {
      if (placeName) this.data.address = placeName;
    },

    onShapeUpdate(points) {
      this.data.shape = Array.isArray(points) ? points : [];

      if (this.data.shape.length > 0) {
        this.data.lat = this.data.shape[0].lat;
        this.data.long = this.data.shape[0].long;
      }
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!Array.isArray(this.data.shape) || this.data.shape.length < 3) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("PLACEHOLDERS.select_points_for_area"));
        return;
      }

      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("name[ar]", this.data.name_ar);
      REQUEST_DATA.append("name[en]", this.data.name_en);
      // REQUEST_DATA.append("radius", this.data.radius);
      // REQUEST_DATA.append("long", this.data.long);
      // REQUEST_DATA.append("lat", this.data.lat);
      this.data.shape.forEach((point, index) => {
        REQUEST_DATA.append(`shape[${index}][lat]`, point.lat);
        REQUEST_DATA.append(`shape[${index}][long]`, point.long);
      });
      REQUEST_DATA.append("address", this.data.address);
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `facilities`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/facilities/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || error.message);
      }
    },
  },
};
</script>
